<template>
  <transition name="fade">
    <div
      v-if="scrollY > 50"
      class="btn-scroll-top"
      @click="scrollTop">
      <i class="icon-top"/>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BtnScrollTop',
  components: {
    mapGetters
  },
  computed: {
  },
  data () {
    return {
      scrollY: 0
    }
  },
  methods: {
    scrollTop: function () {
      // let element = document.querySelector('.main')
      // console.log('element:', element)
      // element.scrollTo(0, Math.floor(this.scrollY * 0.8))
      window.scrollTo(0, Math.floor(this.scrollY * 0.8))
      if (this.scrollY > 0) {
        window.setTimeout(this.scrollTop, 10)
        // scrollToしてる時はスクロールさせないようにする（スクロール中にスクロールさせると挙動が変になる為）
        // element.addEventListener('scroll', function (e) {e.preventDefault()}, {passive: false})
        // element.style.overflow = 'hidden'
      } else if (this.scrollY === 0) {
        // element.style.overflow = ''
      }
    },
    // スクロール値を取得
    getScrollY: function () {
      // this.scrollY = document.querySelector('body').scrollTop
      this.scrollY = window.scrollY
    }
  },
  mounted () {
    // let element = document.querySelector('body')
    // element.addEventListener('scroll', this.getScrollY, false)
    window.addEventListener('scroll', this.getScrollY, false)
  },
  created () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  activated () {
  }
}
</script>
<style lang="postcss" scoped>
  @import '../../assets/css/mixins.css';
  @import '../../assets/css/variables.css';

  .btn-scroll-top {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 50px;
    height: 50px;
    transform: translate3d(0,0,0);
    background: rgba(204, 52, 84, 0.8);
    z-index: 1000;
    cursor: pointer;
    & .icon-top {
      display: block;
      width: 20px;
      height: 20px;
      margin: 15px auto;
      background: url('~@/assets/img/icon-arrowtop.png');
      background-size: 20px;
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/atoms/BtnScrollTop.vue